export default __webpack_public_path__ + "static/home-v3-464f84852dbea9b4c32d9517577227db.png";